import { array, boolean, literal, number, object, preprocess } from 'zod';

import { ProductGroupSchema, SpendBonusSchema } from '@occc/validation';
import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import { BaseSweepstakesSchema } from './base-sweepstakes.schema';

import { SweepstakesType } from '../types';

export const SpendBonusEarningMechanismSchema = SpendBonusSchema.extend({
  accumulationThreshold: number({ required_error: IS_REQUIRED }).positive(IS_POSITIVE),
  ineligibleProductGroups: array(ProductGroupSchema).optional(),
  stayVisibleWhileInProgress: object({ isEnabled: boolean() }).optional(),
});

export const SpendBonusFormSchema = BaseSweepstakesSchema.extend({
  sweepstakesType: literal(SweepstakesType.SpendBonus),
  spendBonus: preprocess((value) => value ?? {}, SpendBonusEarningMechanismSchema),
});
